import { SurveySettings } from '../../types';
import { apiError } from '../../utils/errors';
import { fetchWithRetry } from '../../utils/fetch-with-retry';
import { getApiBaseUrl } from '../../utils/api-base-url';

export interface ThirdPartyData {
  settings: SurveySettings;
}

export const getThirdPartyData = async (
  accountSlug: string,
  trackingId: string,
): Promise<ThirdPartyData> => {
  const response = await fetchWithRetry(
    `${getApiBaseUrl()}/third-parties/${accountSlug}/${trackingId}`,
  );
  const responseJson = await response.json();

  if (!response.ok) {
    throw apiError(response.status, responseJson?.message || 'Failed to fetch third party data', responseJson?.code);
  }

  const data = responseJson.data;

  return data;
};
